import type { GroupedAsset } from '@infinex/asset-config';
import type { ChainKey } from '@infinex/chain-config';

/**
 * Filters the members of a grouped asset to only include the active chains.
 */
export function filterGroupedAssetMembers<T extends GroupedAsset>(
  groupedAsset: T,
  activeChainKeys: ChainKey[]
): T | null {
  const newMembers: GroupedAsset['members'] = {};
  Object.keys(groupedAsset.members).forEach((chain) => {
    const chainAsset = groupedAsset.members[chain as ChainKey];
    if (!chainAsset) {
      return;
    }

    if (activeChainKeys.includes(chain as ChainKey)) {
      newMembers[chain as ChainKey] = chainAsset;
    }
  });

  if (Object.keys(newMembers).length === 0) {
    return null;
  }

  return { ...groupedAsset, members: newMembers };
}
